<template>
  <div>
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-6">
            <h3>REPORTE DESPACHO VERTEDERO</h3>
          </div>
          <div class="col-6 text-right">
            <button class="btn btn-primary btn-icon" @click="cargar_datos">
              <i class="fas fa-filter"></i> Filtrar
            </button>
            <button class="btn btn-success btn-icon" @click="exportar_excel">
              <i class="fas fa-file-excel"></i> Excel
            </button>
          </div>
        </div>

        <div class="row mt-2">
          <div class="col">
            <table class="table table-bordered">
              <tr class="background-light">
                <th>RANGO DE FECHAS</th>
              </tr>
              <tr>
                <td>
                  <date-picker v-model="fechas" :range="true" format="DD-MM-YYYY" :editable="false" :clearable="false"
                    value-type="YYYY-MM-DD"></date-picker>
                </td>
              </tr>
            </table>
          </div>
        </div>

        <div class="row mt-1">
          <div class="col">
            <div class="tableFixHead" style="width: 100%">
              <table class="table table-bordered">
                <thead class="">
                  <tr>
                    <th class="fixed outlineado text-center" :colspan="c.colspan" :style="{backgroundColor: c.color}" v-for="c in cabeceras" :key="c.path">
                      <span class="titulo_tabla_1">{{ c.label }}</span>
                    </th>
                  </tr>
                  <tr>
                    <th class="fixed outlineado text-center" :style="{backgroundColor: c.color}" v-for="c in columnas" :key="c.path">
                      <span class="titulo_tabla_1">{{ c.label }}</span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in datos">
                    <td v-for="c in columnas" class="fila">{{ formatear_valor(item, c.path, c.tipo) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data: () => ({
    fechas: [],
    cabeceras: [
      {label: "Recepción en patio destino a relleno sanitario", color: "#F4B084", colspan: 11},
      {label: "Despachos", color: "#F8CBAD", colspan: 7},
    ],
    columnas: [
      {label: "Fecha Recepción", tipo: "date", path: "fecha_recepcion", ancho_excel: 22, color: "#F4B084"},
      {label: "Hora", tipo: "time", path: "hora_recepcion", ancho_excel: 22, color: "#F4B084"},
      {label: "Ticket", tipo: "string", path: "ticket_recepcion", ancho_excel: 22, color: "#F4B084"},
      {label: "Patente", tipo: "string", path: "patente_recepcion", ancho_excel: 22, color: "#F4B084"},
      {label: "Tipo", tipo: "string", path: "tipo_recepcion", ancho_excel: 22, color: "#F4B084"},
      {label: "Proveedor", tipo: "string", path: "proveedor_recepcion", ancho_excel: 22, color: "#F4B084"},
      {label: "Origen Planta", tipo: "string", path: "origen_recepcion", ancho_excel: 22, color: "#F4B084"},
      {label: "Guía Origen", tipo: "string", path: "guia_recepcion", ancho_excel: 22, color: "#F4B084"},
      {label: "Kgs Guía", tipo: "number", path: "kilos_guia_recepcion", ancho_excel: 22, color: "#F4B084"},
      {label: "Romana (Kgs Netos)", tipo: "number", path: "kilos_romana_recepcion", ancho_excel: 22, color: "#F4B084"},
      {label: "N° de Bins", tipo: "string", path: "bins_recepcion", ancho_excel: 22, color: "#F4B084"},
      {label: "Empresa", tipo: "string", path: "empresa_despacho", ancho_excel: 22, color: "#F8CBAD"},
      {label: "Destino", tipo: "string", path: "destino_despacho", ancho_excel: 22, color: "#F8CBAD"},
      {label: "Guía", tipo: "string", path: "guia_despacho", ancho_excel: 22, color: "#F8CBAD"},
      {label: "Fecha Despacho", tipo: "datetime", path: "fecha_despacho", ancho_excel: 22, color: "#F8CBAD"},
      {label: "Patente", tipo: "string", path: "patente_despacho", ancho_excel: 22, color: "#F8CBAD"},
      {label: "Ticket", tipo: "string", path: "ticket_despacho", ancho_excel: 22, color: "#F8CBAD"},
      {label: "Kilos Ticket", tipo: "number", path: "kilos_ticket_despacho", ancho_excel: 22, color: "#F8CBAD"},
    ],
    datos: [],
    url_excel: null,
  }),
  mounted() {
    this.fechas = [this.$moment().format('YYYY-MM-DD'), this.$moment().format('YYYY-MM-DD')];
    this.cargar_datos();
  },
  methods: {
    async cargar_datos() {
      this.datos = [];
      this.url_excel = null;

      const loader = this.$loading.show({
        // Optional parameters
        canCancel: true,
        color: "#262b63",
        backgroundColor: "#ededed",
        loader: "spinner",
      });

      let url = `${this.api}/reportes/despacho/vertedero`;
      if (this.fechas[0] != null && this.fechas[0] != undefined) {
        url += `/${this.fechas[0]}`;
        url += `/${this.fechas[1]}`;
      }
      await this.axios
        .get(url, this.cabeceras_json)
        .then((res) => {
          this.datos = res.data.data;
          this.url_excel = res.data.url;
        })
        .catch((e) => {
          console.log(e);
        });
      loader.hide();
    },

    async exportar_excel() {
      window.open(this.url_excel, "_blank");
    },

    formatear_valor(item, path, tipo_dato) {
      if (!item[path]) return item[path];

      if (tipo_dato == "datetime") {
        return this.$options.filters.fecha_hora(item[path]);
      }
      if (tipo_dato == "date") {
        return this.$options.filters.fecha(item[path]);
      }
      if (tipo_dato == "time") {
        const valor = this.$moment(item[path]); 
        return valor.isValid() ? valor.format('HH:mm:ss') : item[path];
      }
      if (tipo_dato == 'number') {
        return this.$options.filters.formatear_miles(item[path]);
      }

      return item[path];
    }
  },
  computed: {
    ...mapState(['api', 'api_public', 'cabeceras_json', 'token'])
  }
};
</script>

<style>
.tableFixHead {
  overflow: auto;
  height: 600px;
  border: 1px solid rgb(101, 101, 101);
}

.fixed {
  position: sticky;
  top: 0;
  z-index: 10;
  height: 46px;
}

.fixed-2 {
  position: sticky;
  top: 46px;
  z-index: 10;
}

.outlineado {
  outline: 1px solid rgb(17, 15, 15);
}

.table-bordered th,
.table-bordered td {
  border: 1px solid #afafaf;
}
</style>

<style scoped>
.fila {
  text-align: center;
}
</style>